import React, {
	type ComponentProps,
	useCallback,
	useState,
	useEffect,
	type ReactNode,
} from 'react';

import AKAnalyticsListener from '@atlaskit/analytics-next/AnalyticsListener';

import type { AnalyticsProps } from './types';
import { getAnalyticsWebClient } from './analyticsWebClient';

export const ANALYTICS_CHANNEL = 'embeddedConfluence';

const packageName = process.env._PACKAGE_NAME_ as string;
const packageVersion = process.env._PACKAGE_VERSION_ as string;

export type AnalyticsListenerProps = AnalyticsProps & { children: ReactNode };

const AnalyticsListener = ({
	children,
	embeddedConfluenceSource,
	hostname,
	parentProduct,
	userInfo,
}: AnalyticsListenerProps): React.JSX.Element | null => {
	const [analyticsClient, setAnalyticsClient] = useState<any>(null);

	useEffect(() => {
		getAnalyticsWebClient({ hostname, userInfo }).then((res) => {
			setAnalyticsClient(res);
		});
	}, [hostname, userInfo]);

	const onEvent = useCallback<ComponentProps<typeof AKAnalyticsListener>['onEvent']>(
		({ payload }) => {
			analyticsClient?.onEvent?.(ANALYTICS_CHANNEL, {
				...payload,
				attributes: {
					...payload?.attributes,
					embeddedConfluenceSource,
					packageName,
					packageVersion,
					parentProduct,
				},
			});
		},
		[analyticsClient, parentProduct, embeddedConfluenceSource],
	);

	if (!analyticsClient) {
		return null;
	}

	return (
		<AKAnalyticsListener channel={ANALYTICS_CHANNEL} onEvent={onEvent}>
			{children}
		</AKAnalyticsListener>
	);
};

export default AnalyticsListener;
